/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Born_Fresh_Macaw_LeapInputs */

const fr_born_fresh_macaw_leap = /** @type {(inputs: Born_Fresh_Macaw_LeapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajouter un évenement`)
};

/**

* @param {Born_Fresh_Macaw_LeapInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const born_fresh_macaw_leap = /** @type {((inputs?: Born_Fresh_Macaw_LeapInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Born_Fresh_Macaw_LeapInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_born_fresh_macaw_leap(inputs)
});